module.exports = " <div class=session _v-0609e800=\"\"> <container _v-0609e800=\"\"> <header _v-0609e800=\"\"> <h2 _v-0609e800=\"\">Noter <span class=\"save color-tint\" v-if=!requesting @click=save _v-0609e800=\"\">Gem</span></h2> </header> <text v-if=\"notes || team\" v-show=!saving :initial-text=notes @value=setText _v-0609e800=\"\"> </text> <loader v-if=\"requesting || saving\" _v-0609e800=\"\"></loader> </container> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-0609e800!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/views/Notes.vue
// module id = 732
// module chunks = 2